var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-kefu"},[_c('p',[_vm._v("微信(电话) ："),_c('a',{attrs:{"href":"tel:13522884649"}},[_vm._v("13522884649")])]),_c('p',[_vm._v("联系我时，请说是在“收到乐”平台看到的 谢谢!")]),_c('p',[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/"}},[_vm._v("京ICP备2023015289号@copy right")])]),_c('p',[_vm._v("经营许可证编号 ：京B2-20223568")])])
}]

export { render, staticRenderFns }